import { ApiOperation } from '../../../models'

export class DeviceState {
    register: ApiOperation

    constructor () {
        this.register = new ApiOperation()
    }
}
